import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {HttpService} from './http.service';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InfoService {
  public stageModifiedProductsCounter: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public productionModifiedProductsCounter: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public productionImportUpdateComplete: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public productionImportCreateComplete: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  // Emits when the backend broadcasts push-to-production complete — used to
  // re-enable the Update & Sync / Push to production buttons.
  public pushToProductionComplete: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public rowOnEdit: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public $appReady: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private httpService: HttpService
  ) {
    this.httpService.get(environment.API_PATH + '/product/info').subscribe((resp: any) => {
      this.stageModifiedProductsCounter.next(resp.stageModifiedProductsCounter);
      this.productionModifiedProductsCounter.next(resp.productionModifiedProductsCounter);
    });
  }

  public getChangedStageProductsCounter() {
    this.httpService.get(environment.API_PATH + '/product/info').subscribe((resp: any) => {
      this.stageModifiedProductsCounter.next(resp.stageModifiedProductsCounter);
      this.productionModifiedProductsCounter.next(resp.productionModifiedProductsCounter);
    });
  }

  public update() {
    this.httpService.post(environment.API_PATH + '/changes/info', {}).subscribe((resp: any) => {
      this.stageModifiedProductsCounter.next(resp.stageModifiedProductsCounter);
    });
  }

  public getInfoMessage() {
    this.httpService.get(environment.API_PATH + '/info').subscribe((resp: any) => {});
  }
}
